import { DynamicXy, PositionType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { SplashAnimation } from '../../animations/SplashAnimation';

// types
//-----------------------------------------------------------------------------
export type SplashEffectOptions = {
  position: PositionType;
  assets?: string[];
  amount?: number;
  scale?: DynamicXy;
  tint?: number;
};

/*
    splashing effect
*/
export class SplashEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _position: PositionType;
  private readonly _assets?: string[];
  private readonly _amount: number;
  private readonly _scale: DynamicXy;
  private readonly _tint: number;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: SplashEffectOptions) {
    this._scene = scene;
    this._position = options.position;
    this._assets = options.assets;
    this._amount = options.amount ?? 4;
    this._scale = options.scale ?? { x: 1, y: 1 };
    this._tint = options.tint ?? 0xffffff;
  }

  public static assets(): string[] {
    return [];
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // wait a frame since we async the animation
    await waitAFrame();

    // animate
    this._animate();
  }

  // private: animation
  //-------------------------------------------------------------------------
  private async _animate() {
    // create  animation
    const animation = new SplashAnimation({
      assets: this._assets,
      amount: this._amount,
      scale: this._scale,
      tint: this._tint,
    });
    // spawn animation as overlay
    const entity = spawnOverlayEntity(
      this._scene,
      this._position,
      {},
      () => animation,
    );
    // run animation
    await animation.start();
    // despawn entity
    despawnOverlayEntity(this._scene, entity);
  }
}
